export default class NewsListService {
  getNewsInfo(code) {
    let url = "https://api.tradersr.com/api/newslist?code=" + code;
    console.log(url);
    return fetch(url)
      .then(res => res.json());
  }
}